
const tableColumns = (isNowWaCustomer = false) => {
  const attr = isNowWaCustomer ? [{
    title: '仓实际出入货品数量',
    dataIndex: 'unifyOrderGoodsListNum',
    scopedSlots: { customRender: 'unifyOrderGoodsListNum' },
    width: 200,
  }] : [];
  return [
    {
      title: '订单号',
      dataIndex: 'unifyOdrNo',
      scopedSlots: { customRender: 'unifyOdrNo' },
      fixed: 'left',
      width: 210
    },
    {
      title: '订单状态',
      dataIndex: 'status',
      scopedSlots: { customRender: 'status' },
      width: 160,
    },
    {
      title: '订单类型',
      dataIndex: 'scene',
      scopedSlots: { customRender: 'scene' },
      width: 100
    },
    {
      title: '预计费用(元)',
      dataIndex: 'totalPlanCost',
      scopedSlots: { customRender: 'totalPlanCost' },
      width: 100
    },
    {
      title: '仓货主',
      dataIndex: 'customerName',
      scopedSlots: { customRender: 'customerName' },
      width: 210
    },
    {
      title: '仓库',
      dataIndex: 'warehouse',
      scopedSlots: { customRender: 'warehouse' },
      width: 170
    },
    {
      title: isNowWaCustomer ? '下单货品信息' : '货品信息',
      dataIndex: 'goosInfo',
      scopedSlots: { customRender: 'goosInfo' },
      width: 190
    },
    ...attr,
    {
      title: '运输地点',
      dataIndex: 'consignorAddress',
      scopedSlots: { customRender: 'startAddress' },
      width: 240
    },
    {
      title: '订单总金额(元)',
      dataIndex: 'cost',
      scopedSlots: { customRender: 'orderAmount' },
      width: 150
    },
    {
      title: '派车信息',
      dataIndex: 'dispatchInfo',
      scopedSlots: { customRender: 'dispatchInfo' },
      width: 200
    },
    {
      title: '服务商',
      dataIndex: 'carrierTenantName',
      scopedSlots: { customRender: 'carrierTenantName' },
      customRender: (text, record) => record.ext?.demoData ? '运荔枝演示' : text,
      width: 200
    },
    {
      title: '下单信息',
      dataIndex: 'createTime',
      scopedSlots: { customRender: 'createTime' },
      width: 200
    },
    {
      title: '下单货主',
      dataIndex: 'tenantName',
      scopedSlots: { customRender: 'tenantName' },
      customRender: (text, record) => record.ext?.demoData ? '**餐饮连锁' : text,
      width: 210
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      width: 200
    },
  ]
};

export default tableColumns
